export default __webpack_public_path__ + "static/media/flagged.8b5ba25d.mp3";